import { ColDef, ColGroupDef } from 'ag-grid-community';
import { DashboardShortcutRole } from '../../RolePanelTypes';
import { BasePermissionGrid } from './BasePermissionGrid';

export class DashboardShortcutRoleGrid extends BasePermissionGrid<DashboardShortcutRole> {
    id: string = 'DashboardShortcutRoles';
    gridClass: string = 'permissionGrid';

    protected endpoint: string = '/rolePanel/DashboardShortcutRoles';

    protected getColumnDefs(): (ColDef<any, any> | ColGroupDef<any>)[] {
        return [
            { field: 'Name', headerName: 'Menu Item Name', flex: 3, resizable: false },
            {
                field: 'IsHidden',
                flex: 1,
                resizable: false,
                cellRendererParams: { disabled: false },
            },
        ];
    }
}
